import { resetEditingAction } from 'modules/editing/actions'
import hasScrollToTopRouteUtil from 'modules/routes/utils/has-scroll-to-top'
import 'styles/no-scrollbars-list.css'
import isAppRouteUtil from 'modules/routes/utils/is-app'
import updateRenderCountAppAction from 'modules/app/actions/update-render-count/index.js'
import isDifferentLocationWithoutQueryLocationUtil from 'modules/router/utils/is-different-location-without-query/index.js'
import isDifferentHashLocationUtil from 'modules/router/utils/is-different-hash/index.js'
import scrollToAnchorAppUtil from 'client/utils/dom/app.js'
import isArticleRouterSelect from 'modules/router/selectors/is-article/index.js'
import scrollToTopDomUtil from 'client/utils/dom/scroll-to-top/index.js'
import runAfterDelayPromisifiedPerformanceUtil from 'modules/performance/run-after-delay-promisified/index.js'
import { shouldRenderNotFoundPageSelect } from 'modules/training/modules/app/selectors/shouldRenderNotFoundPage/index.js'
import { updateShouldRenderNotFoundPageAction } from 'modules/app/actions/updateShouldRenderNotFoundPage/index.js'

/**
 * @param props
 * @param props.isDifferentLocation
 * @param props.isEditing
 * @param props.location
 * @param props.prevLocation
 * @param props.scrollToTop
 * @param props.handleTrainingLoadDataOnRouteChange
 * @returns {(function(*, *): void)|*}
 */
export default function handleLocationUpdateAppAction (props) {
  return async (dispatch, getState) => {
    const {
      isDifferentLocation,
      isEditing,
      location,
      prevLocation,
      scrollToTop,
      handleTrainingLoadDataOnRouteChange
    } = props

    const shouldRenderNotFoundPage = shouldRenderNotFoundPageSelect(getState())

    const isArticle = isArticleRouterSelect(getState())
    let hasScrolled = false
    if (isArticle && location?.hash) {
      // Handle article anchor scrolling (on mount or hash change)
      scrollToAnchorAppUtil({
        location
      })
      hasScrolled = true
    }

    if (
      isDifferentLocation &&
      !isEditing
    ) {
      dispatch(resetEditingAction())
    }

    if (isDifferentLocation) {
      dispatch(updateRenderCountAppAction())
    }

    if (
      isDifferentLocation &&
      shouldRenderNotFoundPage
    ) {
      dispatch(updateShouldRenderNotFoundPageAction(false))
    }

    if (
      isDifferentLocation &&
      (
        !location?.search ||
        location?.search.includes('plan=') // TODO improve
      ) &&
      !isEditing
    ) {
      const isSamePage = !(
        isDifferentLocationWithoutQueryLocationUtil(
          prevLocation,
          location
        )
      )
      const isDifferentHash = isDifferentHashLocationUtil(prevLocation, location)

      if (
        isSamePage &&
        isDifferentHash &&
        !isArticle
      ) {
        scrollToAnchorAppUtil({
          location,
          shouldHighlight: false,
          hasDelay: false
        })
      } else if (hasScrollToTopRouteUtil(location) && !hasScrolled) {
        scrollToTop(isSamePage)
      }
    }

    if (
      !isAppRouteUtil(prevLocation?.pathname) &&
      isAppRouteUtil(location?.pathname)
    ) {
      handleTrainingLoadDataOnRouteChange(prevLocation)
      await runAfterDelayPromisifiedPerformanceUtil({
        delay: 0
      })
      scrollToTopDomUtil(true)
    }
  }
}
